var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"authentication-steps"},_vm._l((_vm.steps),function(step,index){return _c('span',{key:index,class:[
      'authentication-step',
      { 'authentication-step--active': _vm.current >= index }
    ]},[_vm._v(_vm._s(step))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }